import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Image } from '@asigna/kit';
import cx from 'classnames';
import LinkIcon from 'images/link_icon.svg';
import LockIcon from 'images/lock-icon.svg';
import proActiveIcon from 'images/proactive.svg';

import s from '../../index.module.scss';

type LinkItem = { path: string; onClick?: () => void };

type ButtonItem = { onClick: () => void };

export type MenuItemProps = {
  icon: string;
  title: string | React.ReactElement;
  disabled?: boolean;
  external?: boolean;
  isActive: boolean;
  pro?: boolean;
  soon?: boolean;
  stacking?: boolean;
  isActivatedPro: boolean;
} & (LinkItem | ButtonItem);

export const MenuItem: React.FC<MenuItemProps> = ({
  icon,
  title,
  isActive,
  disabled,
  external,
  pro,
  soon,
  isActivatedPro,
  stacking,
  ...props
}) => {
  const [isHover, setIsHover] = useState(false);
  const handleMouseEnter = () => setIsHover(true);
  const handleMouseLeave = () => setIsHover(false);

  const menuItemStyle = cx(
    s.item,
    'flex gap-12 items-center py-8 bg-transparent relative group',
    isActive && s.active,
    isActive ? 'text-primary' : isHover ? 'text-white' : 'text-regular',
    disabled && 'opacity-50',
    soon && 'opacity-50'
  );

  const MenuItemContent = (
    <>
      <Image src={icon} size={20} color={isActive ? 'primary' : isHover ? 'white' : 'regular'} />
      {typeof title === 'string' ? <p className="text-r13 text-left">{title}</p> : title}
      {disabled && (
        <img src={LockIcon} width={16} height={16} alt="disabled" className="mr-[-8px]" />
      )}
      {pro && (
        <>
          {soon ? (
            <div className="flex items-center gap-4 justify-center px-8 h-24 text-m13 rounded-[24px] bg-white-10">
              <span className="goldProGradient">Pro</span>
              <span className="text-r12 text-regular">Soon</span>
            </div>
          ) : (
            <div className="flex items-center justify-center w-44 h-24 text-m13 text-[#493B15] rounded-[24px] bg-[linear-gradient(103deg,_#FFE341_0%,_#F7E47D_24.5%,_#F1C855_48.99%,_#FFE2A8_73.49%,_#FFE970_97.99%)]">
              Pro
            </div>
          )}
        </>
      )}

      {!disabled && (
        <>
          {external && <img src={LinkIcon} width={16} height={16} alt="" className="ml-auto" />}
          {soon && (
            <div className="flex items-center bg-white-10 rounded-[24px] px-8 py-[2px] text-r12 text-regular ml-[-8px]">
              Soon
            </div>
          )}
        </>
      )}
      {title === 'Asigna Pro' && (
        <>
          {isActivatedPro ? (
            <img src={proActiveIcon} alt="" />
          ) : (
            <div className="flex items-center justify-center h-28 w-64 rounded-[24px] bg-white-10">
              <span className="text-r12 text-regular">Inactive</span>
            </div>
          )}
        </>
      )}
    </>
  );

  if (stacking) {
    return (
      <button onClick={props.onClick} className={menuItemStyle}>
        {MenuItemContent}
      </button>
    );
  }
  if ('path' in props && external) {
    return (
      <a
        href={props.path}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={menuItemStyle}
        target="_blank"
        rel="noreferrer"
      >
        {MenuItemContent}
      </a>
    );
  }
  if ('path' in props && !disabled && !soon) {
    return (
      <Link
        to={props.path}
        onClick={() => !disabled && props.onClick && props.onClick()}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={menuItemStyle}
      >
        {MenuItemContent}
      </Link>
    );
  }

  return (
    <button disabled={disabled} onClick={props.onClick} className={menuItemStyle}>
      {MenuItemContent}
    </button>
  );
};
